( function () {   
    'use strict';
    ( function ( $ ) {
    if($('.hospitality-image-slider').length >0 ){
        $('.hospitality-image-slider').slick({
          dots: false,
          infinite: false,
          speed: 600,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay:false,
          arrows:true,
          rows:0,
          responsive: [
            {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                }
            }
          ]
        });
      }
    })( jQuery );
} )();

